'use client'

import React from 'react'
import Seo from '../../components/Seo'
import { Mail } from 'lucide-react'

const TermsOfServicePage = () => {
  const pageUrl = '/terms-of-services'

  return (
    <>
      <Seo
        title="Terms of Service – Xentovra Global"
        description="Read Xentovra Global's terms of service and understand the conditions for using our website and services."
        url={pageUrl}
        breadcrumbItems={[
          { name: 'Home', url: 'https://www.xentovra-globals.com/' },
          { name: 'Terms of Service', url: 'https://www.xentovra-globals.com/terms-of-services' },
        ]}
      />
      
      <main className="privacy-policy bg-light-blue">
        <div className="page-header-section">
          <h1 className="section-heading">
            Terms of Services
          </h1>
          <p className="update-date"> Effective Date : Nov 1 2025 </p>
        </div>
        <section className="section-padding privacy-policy-section">
          <div className="section-container">
            <div className="privacy-content">
              <div className="privacy-text">
                <p className="normal-text company-description">
                  Welcome to Xentovra Global. By accessing or using our website and services, 
                  you agree to the following terms:
                </p>
               <div className="privacy-text-content"> 
                  <h2 className="text-heading">1. Use of Website</h2>      
                  <ul>
                    <li className="normal-text">You may use our website for lawful purposes only.</li>
                    <li className="normal-text">You agree not to misuse, copy, or exploit any part of our website or content without prior written permission.</li>
                  </ul>
                </div>
                <div className="privacy-text-content"> 
                  <h2 className="text-heading">2. Intellectual Property</h2>
                  <p className="normal-text">
                    All content, logos, and trademarks displayed on this website are the property of Xentovra Global. 
                    Unauthorized use is strictly prohibited.
                  </p>
                </div>
                <div className="privacy-text-content"> 
                  <h2 className="text-heading">3. Services</h2>
                  <ul>
                    <li className="normal-text">Services offered are subject to mutual agreement and formal contracts.</li>
                    <li className="normal-text">We reserve the right to modify or discontinue any service without prior notice.</li>
                  </ul>
                </div>
                <div className="privacy-text-content"> 
                  <h2 className="text-heading">4. Limitation of Liability</h2>
                  <ul>
                    <li className="normal-text">We strive to ensure accuracy of information but do not guarantee completeness or reliability.</li>
                    <li className="normal-text">Xentovra Global will not be held responsible for any direct, indirect, or incidental damages arising from the use of our services or website.</li>
                  </ul>
                </div>
                <div className="privacy-text-content"> 
                  <h2 className="text-heading">5. Payments & Contracts</h2>
                  <ul>
                    <li className="normal-text">All projects or services will be governed by written agreements signed between Xentovra Global and the client.</li>
                    <li className="normal-text">Payment terms, timelines, and deliverables will be clearly defined in each agreement.</li>
                  </ul>
                </div>
                <div className="privacy-text-content"> 
                  <h2 className="text-heading">6. Termination</h2>
                  <p className="normal-text">
                    We reserve the right to suspend or terminate access to our website or services if users violate these terms.
                  </p>
                </div>
                <div className="privacy-text-content"> 
                  <h2 className="text-heading">7. Governing Law</h2>
                  <p className="normal-text">
                    These Terms shall be governed by and construed in accordance with the laws of India.
                  </p>
                </div>
                <div className="privacy-text-content"> 
                  <h2 className="text-heading">8. Contact Us</h2>
                  <p className="normal-text mb-8">For inquiries regarding these Terms, reach us at:</p>
                  <p className="normal-text">
                     <a href="mailto:info@xentovra-globals.com" className="contact-link"> <Mail size={16} strokeWidth={2} /> info@xentovra-globals.com</a>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
    </>
  )
}

export default TermsOfServicePage
